/** Valores editáveis de um item; nulos usam o valor da nota ou do cadastro do produto. */
export class NFeEntradaFormacaoPrecosItemPreviaRequest {
  public identificador = '';
  public valorDifal: number | null = null;
  /** Nulo usa o markup do produto ou, sem ele, o padrão da configuração de custo e venda. */
  public percentualMarkup: number | null = null;
  /**
   * Preço de venda digitado. Quando vem, vale no lugar do markup: o servidor define o markup sobre a base do modelo em
   * uso e devolve o markup e o preço calculados.
   */
  public precoVendaInformado: number | null = null;
}
